// vwa namespace
var VWA = {};

VWA.Utils = function Utils() {

    return {
        /**
         * Function GetQueryParamenters
         * @returns {string} -  the parameters from the hashed query string
         **/
        GetQueryParameters: function () {

            let params = {};
            let hash = window.location.hash;
            let index = hash.indexOf('?') + 1;
         

            if (index < 1) {
                return params;
            }

            let query = hash.substr(index, hash.length - index).split('&');

            for (let i in query) {
                var nameval = query[i].split('=');
                params[nameval[0]] = nameval[1];
            }
            return params;
        }
    };
}();

export default VWA;



// WEBPACK FOOTER //
// ./Vue/Src/Services/Utils.js